import { IAutomationListResponse } from 'modules/settings/models';
import API from 'services/api';

export const getAutomations = (): Promise<IAutomationListResponse> =>
  API.get('api/automation').then(response => response?.data);
